/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Button } from "../../../components";
import { toast } from "react-toastify";
import {
  GetAvailableSessions,
  GetSessionDetails,
} from "../../../utilities/api/session";
import { emailValidation, nameValidation } from "../../../utilities/utils";
import {
  GetSportsDetails,
  GetSportsForFacility,
} from "../../../utilities/api/sports/indext";
import { useNavigate } from "react-router-dom";
import { CustomerCoachingBookingStep1 } from "./CustomerCoachingBookingStep1";
import { CustomerCoachingBookingStep2 } from "./CustomerCoachingBookingStep2";
import { CustomerCoachingBookingStep3 } from "./CustomerCoachingBookingStep3";
import { CustomerCoachingBookingStep4 } from "./CustomerCoachingBookingStep4";
import { countWeeks } from "../../Coaching/session.utils";
import { format } from "date-fns";
import { CustomerCoachingBookingStep5 } from "./CustomerCoachingBookingStep5";
import { messages } from "../../../utilities/Messages";

const getMessage = messages.customerCoachingSessionBooking;

const CustomerCoachingBooking = () => {
  const { SelectedFacility } = useAppSelector((state) => state.facilityList);
  const { UserDetails } = useAppSelector((state) => state.verifiedUser);

  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [data, setData] = useState({
    facilityId: SelectedFacility ? Number(SelectedFacility) : "",
    sportId: "",
    sessionId: "",
    firstName: UserDetails.firstName,
    lastName: UserDetails.lastName,
    email: UserDetails.email,
    noOfDays: "",
    noOfWeeks: "",
    selectedSlots: [],
    startDate: "",
    schoolName: "",
    parentName: "",
    whatsAppNumber: "",
    gender: UserDetails.gender,
    birthDate: UserDetails.birthDate?.split("/").reverse().join("-") || "",
    aadharNumber: "",
    haveIdProof: "true",
    addressLine1: UserDetails.addressLine1 || "",
    addressLine2: UserDetails.addressLine2 || "",
    city: UserDetails.city || "",
    state: UserDetails.state || "",
    country: "India",
    pincode: UserDetails.pincode || "",
    landmark: "",
    latitude: "",
    longitude: "",
    isIgstTax: "false",
    paymentMode: "instant",
    paymentMethod: "online",
  });
  const [sportData, setSportData] = useState<any>({});
  const [AllSessionsData, setAllSessionData] = useState([]) as any;
  const [sessionData, setSessionData] = useState<any>({});
  const [error, setError] = useState({
    sportId: "",
    sessionId: "",
    noOfDays: "",
    selectedSlots: "",
    noOfWeeks: "",
    startDate: "",
    gender: "",
    birthDate: "",
    addressLine1: "",
    addressLine2: "",
    landmark: "",

    city: "",
    state: "",
    pincode: "",
    email: "",
    firstName: "",
    lastName: "",
    whatsAppNumber: "",
    parentName: "",
    schoolName: "",
  });
  const [sportList, setSportList] = useState([]) as any;
  const [sessionRule, setSessionRule] = useState([]);

  useEffect(() => {
    if (data?.sportId && data?.noOfDays) {
      GetAvailableSessions(SelectedFacility, data?.sportId, `${data?.noOfDays}`)
        .then((res: any) => {
          setAllSessionData(res?.data?.rows);
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message || getMessage.something_wrong);
        });
    }
  }, [data?.sportId, data?.noOfDays]);

  const GetSport = async () => {
    const result = await GetSportsForFacility(SelectedFacility);
    if (result.statusCode == 200) {
      setSportList(result.data.rows);
    } else {
      toast.error(result.response.data.message);
    }
  };

  useEffect(() => {
    handleUpdate("sessionId", null);
    handleUpdate("sportId", "");
    setSportData({});
    GetSport();
    setData({ ...data, facilityId: Number(SelectedFacility) || "" });
    if (SelectedFacility === "") {
      toast.error(getMessage.facility_select);
    }
  }, [SelectedFacility]);

  useEffect(() => {
    handleUpdate("sessionId", "");
    setSessionData({});
    if (data?.sportId) {
      GetSportsDetails(data?.sportId)
        ?.then((res: any) => {
          setSportData(res?.data);
        })
        ?.catch((error) => toast.error(error.message));
    }
  }, [data?.sportId]);

  useEffect(() => {
    if (data?.sessionId) {
      GetSessionDetails(data?.sessionId)
        ?.then((res: any) => {
          setSessionData(res?.data);
        })
        ?.catch((error) => toast.error(error.message));
    }
  }, [data?.sessionId]);

  const handleBack = () => {
    setCurrentStep((_oldVal) => {
      if (_oldVal > 0) {
        return --_oldVal;
      } else {
        return _oldVal;
      }
    });
  };

  const handleUpdate = (key: any, value: any) => {
    if (typeof key === "object") {
      setData((_oldData) => ({ ..._oldData, ...key }));
    } else {
      setData((_oldData) => ({ ..._oldData, [key]: value }));
    }
  };

  const handleHome = () => {
    navigate("/customer-dashboard");
  };

  const handleNext = () => {
    if (currentStep === 0 && !isStepOneValid()) {
      return false;
    }
    if (currentStep === 1 && !isStepTwoValid()) {
      return false;
    }

    if (currentStep === 2 && !isStepThreeValid()) {
      setError({
        ...error,
        gender: data?.gender ? "" : getMessage.gender_required,
        email: "",
        birthDate: !data?.birthDate
          ? getMessage.dateOfBirth_required
          : new Date(data?.birthDate + "T00:00:00") <= new Date()
            ? ""
            : getMessage.dateOfBrith_isNotnfuture,
        // addressLine1: data?.addressLine1
        //   ? data?.addressLine1.length > 50
        //     ? getMessage.addressLine1_maxLength
        //     : ""
        //   : getMessage.addressLine1_required,
        addressLine1: data?.addressLine1.length > 50
          ? getMessage.addressLine1_maxLength
          : "",
        addressLine2:
          data?.addressLine2.length > 50
            ? getMessage.addressLine2_maxLength
            : "",
        landmark:
          data?.landmark.length > 50
            ? getMessage.landmark_maxLength
            : "",
        // city: data?.city ? "" : getMessage.city_required,
        city: data?.city ? "" : "",
        // state: data?.state ? "" : getMessage.state_required,
        state: data?.state ? "" : "",
        // pincode: data?.pincode?.length == 6 ? "" : getMessage.pincode_length,
        pincode: data?.pincode?.length == 6 ? "" : "",
        firstName:
          data?.firstName?.length < 3 || data?.firstName?.length > 30
            ? getMessage.firstName_min_max_length
            : nameValidation(data?.firstName) == null
              ? getMessage.firstName_matches
              : "",
        lastName:
          data?.lastName?.length < 1 || data?.lastName?.length > 30
            ? getMessage.lastName_min_max_length
            : nameValidation(data?.lastName) == null
              ? getMessage.lastName_matches
              : "",
        whatsAppNumber:
          data.whatsAppNumber != ""
            ? data.whatsAppNumber.length == 10
              ? ""
              : getMessage.whatsApp_min_max_length
            : getMessage.whatsApp_required,

        schoolName:
          data.schoolName == ""
            ? ""
            : data.schoolName.length > 100
              ? getMessage.schoolName_maxLength
              : nameValidation(data.schoolName) != null
                ? ""
                : getMessage.schoolName_matches,

        parentName:
          data.parentName == ""
            ? ""
            : data.parentName.length > 60
              ? getMessage.parentName_maxLength
              : nameValidation(data.parentName) != null
                ? ""
                : getMessage.parentName_matches,
      });
      return false;
    }
    if (currentStep === 2 && isStepThreeValid()) {
      setError({
        ...error,
        gender: "",
        birthDate: "",
        addressLine1: "",
        city: "",
        state: "",
        pincode: "",
        firstName: "",
        lastName: "",
        whatsAppNumber: "",
        parentName: "",
        schoolName: "",
      });
    }

    setCurrentStep((_oldVal) => {
      if (_oldVal < 4) {
        return ++_oldVal;
      } else {
        return _oldVal;
      }
    });
  };

  const isStepOneValid = () => {
    if (!data.sportId || !data.sessionId || !data.noOfDays) {
      setError({
        ...error,
        sportId: !data.sportId ? getMessage.sport_required : "",
        sessionId: !data.sessionId ? getMessage.session_required : "",
        noOfDays: !data.noOfDays ? getMessage.numberofSession_required : "",
      });
      return false;
    } else {
      setError({ ...error, sportId: "", sessionId: "", noOfDays: "" });
      return true;
    }
  };

  const isStepTwoValid = () => {
    if (
      !data.selectedSlots ||
      !data.noOfWeeks ||
      data.noOfWeeks.toString().length > 2 ||
      !data.startDate
    ) {
      setError({
        ...error,
        selectedSlots: data.selectedSlots.length <= 0 ? getMessage.days_required : "",
        noOfWeeks: !data.noOfWeeks
          ? getMessage.weeks_for_booking_required
          : data.noOfWeeks.toString().length > 2
            ? getMessage.weeks_for_booking_length
            : "",
        startDate: !data.startDate ? getMessage.startDate_required : "",
      });
      return false;
    } else {
      setError({
        ...error,
        selectedSlots: "",
        noOfWeeks: "",
        startDate: "",
      });
    }
    if (data?.selectedSlots?.length < Number(data?.noOfDays)) {
      toast.error(
        `Number of selected slots are less than selected number of days per week. Select at least ${data?.noOfDays} slots.`
      );
      return false;
    }
    if (data?.noOfWeeks < sessionData?.minWeeksToBook) {
      toast.error(
        `Selected Weeks are less than minimum number of Week to Book. Please select at least ${sessionData?.minWeeksToBook} Week.`
      );
      return false;
    }
    if (
      Number(data?.noOfWeeks) >
      countWeeks(
        new Date(),
        new Date(sessionData.endDate.split("/").reverse().join("/"))
      )
    ) {
      toast.error(
        `Selected Weeks are More than Maximum number of Week can Book. Please select between ${sessionData?.minWeeksToBook
        } to ${countWeeks(
          new Date(),
          new Date(sessionData.endDate.split("/").reverse().join("/"))
        )} Week.`
      );
      return false;
    }
    if (
      Number(data?.noOfWeeks) >
      countWeeks(
        new Date(format(new Date(data.startDate), "yyyy/MM/dd")),
        new Date(sessionData.endDate.split("/").reverse().join("/"))
      )
    ) {
      toast.error(
        `Selected Weeks are More than Available Week to Book. Please select between ${sessionData?.minWeeksToBook
        } to ${countWeeks(
          new Date(format(new Date(data.startDate), "yyyy/MM/dd")),
          new Date(sessionData.endDate.split("/").reverse().join("/"))
        )} Week.`
      );
      return false;
    }

    return true;
  };

  const isStepThreeValid = () => {
    if (
      (data.schoolName != "" && nameValidation(data.schoolName) == null) ||
      data.schoolName.length > 100
    ) {
      return false;
    }
    if (
      (data.parentName != "" && nameValidation(data.parentName) == null) ||
      data.schoolName.length > 60
    ) {
      return false;
    }
    return (
      // data?.gender &&
      data?.birthDate &&
      new Date(data?.birthDate + "T00:00:00") <= new Date() &&
      // data?.addressLine1 &&
      data?.addressLine1.length < 50 &&
      data?.addressLine2.length < 50 &&
      data?.landmark.length < 50 &&
      // data?.city &&
      // data?.state &&
      // data?.pincode?.length == 6 &&
      data?.paymentMode &&

      data.firstName != "" &&
      data.firstName.length <= 30 &&
      nameValidation(data.firstName) != null &&
      data.lastName != "" &&
      data.lastName.length <= 30 &&
      nameValidation(data.lastName) != null &&
      data.whatsAppNumber != "" &&
      data.whatsAppNumber.length == 10
    );
  };

  return (
    <>
      <Container fluid className="g-0">
        <Card>
          <Card.Body>
            {currentStep !== 0 && (
              <>
                <Row>
                  <Col className="text-start">
                    <Button
                      type="button"
                      bname="Back"
                      name="back"
                      id="back"
                      className="btn btn-primary rounded-1 me-3"
                      onClick={handleBack}
                    ></Button>
                  </Col>
                </Row>
                <hr />
              </>
            )}
            {currentStep === 0 && (
              <CustomerCoachingBookingStep1
                data={data}
                updateData={handleUpdate}
                allSportsData={sportList}
                allSessionsData={AllSessionsData}
                handleHome={handleHome}
                handleNext={handleNext}
                error={error}
                setSessionRule={setSessionRule}
              />
            )}
            {currentStep === 1 && (
              <CustomerCoachingBookingStep2
                updateData={handleUpdate}
                data={data}
                sessionData={sessionData}
                sportData={sportData}
                handleHome={handleHome}
                handleNext={handleNext}
                error={error}
              />
            )}
            {currentStep === 2 && (
              <CustomerCoachingBookingStep3
                data={data}
                updateData={handleUpdate}
                handleNext={handleNext}
                error={error}
              />
            )}
            {currentStep === 3 && (
              <CustomerCoachingBookingStep4
                sportData={sportData}
                sessionRule={sessionRule}
                handleNext={handleNext}
              />
            )}
            {currentStep === 4 && (
              <CustomerCoachingBookingStep5
                data={data}
                sessionData={sessionData}
                isStepOneValid={isStepOneValid}
                isStepTwoValid={isStepTwoValid}
                isStepThreeValid={isStepThreeValid}
              />
            )}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};
export { CustomerCoachingBooking };
